export default function IsUser(to, from, next) {
  const user = localStorage.getItem('storyPhonesUser');
  if (user !== null) {
    next('/dashboard');
  }
  next();
}
